export default __webpack_public_path__ + "static/media/$25.390bfa6b.png";